import React from "react"
import { useTranslation } from "react-i18next"

import { IconSize } from "shared/types/Icon"
import { Button, ButtonVariant } from "shared/ui/buttons/Button"
import { Icon } from "shared/ui/icon/Icon"
import { IconName } from "shared/ui/icon/__generated__/IconName"

import "./styles/_error-page.scss"

interface ErrorPageViewProps {
  navigate: () => void
}

export const ErrorPageView = React.memo(({ navigate }: ErrorPageViewProps) => {
  const { t } = useTranslation()
  return (
    <div id="error-page" className="error-page">
      <Icon name={IconName.MOOD_SAD} size={IconSize.XXXL} />
      <div className="error-label">{t("Error.DialogTitle")}</div>
      <Button variant={ButtonVariant.TERTIARY} onClick={navigate}>
        {t("Error.ToHome")}
      </Button>
    </div>
  )
})
